// @flow

import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { createLinkLocation } from '@seek/ca-jobapply-integration';
import { Button } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

import styles from './ApplyButton.less';

const AnchorButton = props => <Button component="a" {...props} />;

const mapStateToProps = ({ jobdetails, location }) => ({
  job: jobdetails.result,
  query: location.query
});

type ApplyButtonProps = {
  query: Object,
  job: ChaliceJobDetail
};

const ApplyButton = ({ job, query }: ApplyButtonProps) => {
  const { isLinkOut } = job;
  const searchRequestTokenQuery = get(query, 'searchrequesttoken');
  const urlStr = createLinkLocation(
    job,
    searchRequestTokenQuery
      ? `searchrequesttoken=${searchRequestTokenQuery}`
      : ''
  );
  const linkOutRel = isLinkOut ? 'noopener noreferrer ' : '';

  return (
    <NavLink
      analytics="job-details-apply-button-clicked"
      className={styles.applyLink}
      fullWidth
      color="pink"
      component={AnchorButton}
      data-automation="job-detail-apply"
      location={urlStr}
      rel={`${linkOutRel}nofollow`}
      target={isLinkOut ? '_blank' : ''}
    >
      Apply<span className={styles.extraCopy}> for this job</span>
    </NavLink>
  );
};

export default connect(mapStateToProps)(ApplyButton);
